import type {
  ResultServer,
  InvitListPageType,
  ProcessPageFlowType,
  ProcessPageFlowItemType,
  DigitalQueryClassifytree,
  DigitalPageVideo,
  FileType,
  AuditCount,
  AuditTaskDetail,
  DictSearchDisplayType,
  AuthLogin,
  QuestionItem,
  QuestionCategoryItem,
  RandomGenerationQuestion,
  CountIndexData,
  ScoreList,
} from "./api.d";

export enum ApiType {
  API_INVIT_LIST_PAGE = "API_INVIT_LIST_PAGE",
  API_INVIT_LIST_PAGE_SEARCH = "API_INVIT_LIST_PAGE_SEARCH",
  API_INVIT_UPDATE = "API_INVIT_UPDATE",
  API_INVIT_ADD = "API_INVIT_ADD",
  API_INVIT_SEND = "API_INVIT_SEND",
  API_INVIT_DELETE = "API_INVIT_DELETE",
  API_PROCESS_PAGE_FLOW = "API_PROCESS_PAGE_FLOW",
  API_PROCESS_ADD_AUDITOR = "API_PROCESS_ADD_AUDITOR",
  API_PROCESS_INIT_FLOW = "API_PROCESS_INIT_FLOW",
  API_PROCESS_PUBLISH_FLOW = "API_PROCESS_PUBLISH_FLOW",
  API_PROCESS_QUERY_FLOW = "API_PROCESS_QUERY_FLOW",
  API_PROCESS_QUERY_NODE = "API_PROCESS_QUERY_NODE",
  API_PROCESS_FLOW_SAVE = "API_PROCESS_FLOW_SAVE",
  API_PROCESS_FLOW_UPDATE = "API_PROCESS_FLOW_UPDATE",
  API_AUDIT_COUNT = "API_AUDIT_COUNT",
  API_AUDIT_PAGE_TASK = "API_AUDIT_TASK",
  API_AUDIT_PAGE_TASK_AI_AUDIT = "API_AUDIT_PAGE_TASK_AI_AUDIT",
  API_AUDIT_PAGE_TASK_MANUAL = "API_AUDIT_PAGE_TASK_MANUAL",
  API_AUDIT_PAGE_TASK_OFFLINE = "API_AUDIT_PAGE_TASK_OFFLINE",
  API_AUDIT_TASK_DETAIL = "API_AUDIT_TASK_DETAIL",
  API_AUDIT_RESULT = "API_AUDIT_RESULT",
  API_DIGITAL_ADD_CLASSIFY = "API_DIGITAL_ADD_CLASSIFY",
  API_DIGITAL_ADD_VIDEO = "API_DIGITAL_ADD_VIDEO",
  API_DIGITAL_EDIT_VIDEO = "API_DIGITAL_EDIT_VIDEO",
  API_DIGITAL_PAGE_VIDEO = "API_DIGITAL_PAGE_VIDEO",
  API_DIGITAL_QUERY_CLASSIFYTREE = "API_DIGITAL_QUERY_CLASSIFYTREE",
  API_FILE_UPLOAD = "API_FILE_UPLOAD",
  API_AUDIT_PAGEURGENTTASK = "API_AUDIT_PAGEURGENTTASK",
  API_DIGITAL_DELETE_CLASSIFY = "API_DIGITAL_DELETE_CLASSIFY",
  API_DIGITAL_DELETE_VIDEO = "API_DIGITAL_DELETE_VIDEO",
  API_AUTH_LOGIN = "API_AUTH_LOGIN",
  API_AUTH_LOGINOUT = "API_AUTH_LOGINOUT",
  API_DICT_ADD = "API_DICT_ADD",
  API_DICT_DELETE = "API_DICT_DELETE",
  API_DICT_PAGE = "API_DICT_PAGE",
  API_DICT_UPDATE = "API_DICT_UPDATE",
  API_DICT_DESC = "API_DICT_DESC",
  API_DICT_SEARCH_DISPLAY_TYPE = "API_DICT_SEARCH_DISPLAYTYPE",
  API_QUESTION_PAGE = 'API_QUESTION_PAGE',
  API_QUESTION_CREATE = 'API_QUESTION_CREATE',
  API_QUESTION_DELETE = 'API_QUESTION_DELETE',
  API_QUESTION_UPDATE = 'API_QUESTION_UPDATE',
  API_QUESTION_CATEGORY_TREE = 'API_QUESTION_CATEGORY_TREE',
  API_QUESTION_CATEGORY_CREATE = 'API_QUESTION_CATEGORY_CREATE',
  API_QUESTION_CATEGORY_DELETE = 'API_QUESTION_CATEGORY_DELETE',
  API_AUTH_VERIFYLOGIN = 'API_AUTH_VERIFYLOGIN',
  API_QUESTION_RANDOM_GENERATION_QUESTION = 'API_QUESTION_RANDOM_GENERATION_QUESTION',
  API_AUTH_GETUSERINFO = 'API_AUTH_GETUSERINFO',
  API_CREATE_CLOUD_VIDEO = 'API_CREATE_CLOUD_VIDEO',
  API_CREATECLOUD_ARCHIVING = 'API_CREATECLOUD_ARCHIVING',
  API_CREATECLOUD_DELETE = 'API_CREATECLOUD_DELETE',
  API_INDEX_COUNTINDEXDATA = 'API_INDEX_COUNTINDEXDATA',
  API_AUDIT_GETSCORELIST = 'API_AUDIT_GETSCORELIST',
  API_AUDIT_GET_CURRENT_TIME_MILLIS = 'API_AUDIT_GET_CURRENT_TIME_MILLIS',
  API_VIDEOMAKER_GETPROGRESS = 'API_VIDEOMAKER_GETPROGRESS',
  API_VIDEOMAKER_VIDEOMAKEADVANCED = 'API_VIDEOMAKER_VIDEOMAKEADVANCED',
  API_VIDEOMAKER_VIDEOPREVIEW = 'API_VIDEOMAKER_VIDEOPREVIEW',
}

export const ApiUrls: Record<ApiType, string> = {
  [ApiType.API_INVIT_LIST_PAGE]: "/system-service/invite/pageInvitedCode",// "/system-service/invitedInfo/listPage",pageInvitedCode
  [ApiType.API_INVIT_LIST_PAGE_SEARCH]: "/system-service/invitedInfo",
  [ApiType.API_INVIT_UPDATE]: "/system-service/invite/update",
  [ApiType.API_INVIT_ADD]: "/system-service/invite/add",
  [ApiType.API_INVIT_SEND]: "/system-service/invite/sendBatchInvitedLink",
  [ApiType.API_INVIT_DELETE]: "/system-service/invite/delete",
  [ApiType.API_PROCESS_PAGE_FLOW]: "/system-service/flow/pageFlow",
  [ApiType.API_PROCESS_ADD_AUDITOR]: "/system-service/flow/addAuditor",
  [ApiType.API_PROCESS_INIT_FLOW]: "/system-service/flow/initializeFLow",
  [ApiType.API_PROCESS_PUBLISH_FLOW]: "/system-service/flow/publishOrRollbackFLow",
  [ApiType.API_PROCESS_QUERY_FLOW]: "/system-service/flow/queryFlowDetail",
  [ApiType.API_PROCESS_QUERY_NODE]: "/system-service/flow/queryNodesByStepId",
  [ApiType.API_PROCESS_FLOW_SAVE]: "/system-service/flow/saveFLow",
  [ApiType.API_PROCESS_FLOW_UPDATE]: "/system-service/flow/updateFlow",
  [ApiType.API_AUDIT_COUNT]: "/system-service/audit/taskStatistics",
  [ApiType.API_AUDIT_PAGE_TASK]: "/system-service/audit/pageTask",
  [ApiType.API_AUDIT_PAGE_TASK_AI_AUDIT]: "/system-service/audit/pageTaskAiAudit",
  [ApiType.API_AUDIT_PAGE_TASK_MANUAL]: "/system-service/audit/pageTaskManual",
  [ApiType.API_AUDIT_PAGE_TASK_OFFLINE]: "/system-service/audit/pageTaskOffline",
  [ApiType.API_AUDIT_TASK_DETAIL]: "/system-service/audit/queryTaskDetail",
  [ApiType.API_AUDIT_RESULT]: "/system-service/audit/submitAuditResult",
  [ApiType.API_AUDIT_PAGEURGENTTASK]: "/system-service/audit/pageUrgentTask",
  [ApiType.API_AUDIT_GETSCORELIST]: "/system-service/audit/getScoreList",
  [ApiType.API_AUDIT_GET_CURRENT_TIME_MILLIS]: "/system-service/audit/getCurrentTimeMillis",
  [ApiType.API_DIGITAL_DELETE_CLASSIFY]: "/system-service/digital/deleteClassify",
  [ApiType.API_DIGITAL_DELETE_VIDEO]: "/system-service/digital/deleteVideo",
  [ApiType.API_DIGITAL_ADD_CLASSIFY]: "/system-service/digital/addClassify",
  [ApiType.API_DIGITAL_ADD_VIDEO]: "/system-service/digital/addVideo",
  [ApiType.API_DIGITAL_EDIT_VIDEO]: "/system-service/digital/modifyVideo",
  [ApiType.API_DIGITAL_PAGE_VIDEO]: "/system-service/digital/pageVideo",
  [ApiType.API_DIGITAL_QUERY_CLASSIFYTREE]: "/system-service/digital/queryClassifyTree",
  [ApiType.API_FILE_UPLOAD]: "/system-service/file/upload",
  [ApiType.API_AUTH_LOGIN]: "/system-service/auth/login",
  [ApiType.API_AUTH_LOGINOUT]: "/system-service/auth/loginOut",
  [ApiType.API_AUTH_VERIFYLOGIN]: "/system-service/auth/verifyLogin",
  [ApiType.API_AUTH_GETUSERINFO]: "/system-service/auth/getUserInfo",
  [ApiType.API_DICT_ADD]: "/system-service/sys/dict/addDict",
  [ApiType.API_DICT_DELETE]: "/system-service/sys/dict/deleteDict",
  [ApiType.API_DICT_PAGE]: "/system-service/sys/dict/page/dict",
  [ApiType.API_DICT_UPDATE]: "/system-service/sys/dict/updateDict",
  [ApiType.API_DICT_DESC]: "/system-service/sys/dict",
  [ApiType.API_DICT_SEARCH_DISPLAY_TYPE]: "/system-service/sys/dict/dictDisplayType",
  [ApiType.API_QUESTION_PAGE]: "/system-service/question/pageQuestion",
  [ApiType.API_QUESTION_CREATE]: "/system-service/question/addQuestion",
  [ApiType.API_QUESTION_DELETE]: "/system-service/question/deleteQuestion",
  [ApiType.API_QUESTION_UPDATE]: "/system-service/question/modifyQuestion",
  [ApiType.API_QUESTION_CATEGORY_TREE]: "/system-service/question/queryClassifyTree",
  [ApiType.API_QUESTION_CATEGORY_CREATE]: "/system-service/question/addClassify",
  [ApiType.API_QUESTION_CATEGORY_DELETE]: "/system-service/question/deleteClassify",
  [ApiType.API_QUESTION_RANDOM_GENERATION_QUESTION]: "/system-service/question/randomGenerationQuestion",
  [ApiType.API_CREATE_CLOUD_VIDEO]: "/system-service/createCloudVideo/listPage",
  [ApiType.API_CREATECLOUD_ARCHIVING]: "/system-service/createCloudVideo/archivingVideo",
  [ApiType.API_CREATECLOUD_DELETE]: "/system-service/createCloudVideo/delete",
  [ApiType.API_INDEX_COUNTINDEXDATA]: "/system-service/index/countIndexData",
  [ApiType.API_VIDEOMAKER_GETPROGRESS]: "/system-service/videomaker/getProgress",
  [ApiType.API_VIDEOMAKER_VIDEOMAKEADVANCED]: "/system-service/videomaker/videoMakeAdvanced",
  [ApiType.API_VIDEOMAKER_VIDEOPREVIEW]: "/system-service/videomaker/videoPreview",
  
}
export interface ApiResp {
  [ApiType.API_INVIT_LIST_PAGE]: InvitListPageType;
  [ApiType.API_INVIT_LIST_PAGE_SEARCH]: ResultServer<any>;
  [ApiType.API_INVIT_UPDATE]: ResultServer<any>;
  [ApiType.API_INVIT_ADD]: ResultServer<any>;
  [ApiType.API_INVIT_SEND]: ResultServer<any>;
  [ApiType.API_INVIT_DELETE]: ResultServer<any>;
  [ApiType.API_PROCESS_PAGE_FLOW]: ProcessPageFlowType;
  [ApiType.API_PROCESS_ADD_AUDITOR]: ResultServer<any>;
  [ApiType.API_PROCESS_INIT_FLOW]: ResultServer<ProcessPageFlowItemType>;
  [ApiType.API_PROCESS_PUBLISH_FLOW]: ResultServer<any>;
  [ApiType.API_PROCESS_QUERY_FLOW]: ResultServer<any>;
  [ApiType.API_PROCESS_QUERY_NODE]: ResultServer<any>;
  [ApiType.API_PROCESS_FLOW_SAVE]: ResultServer<any>;
  [ApiType.API_PROCESS_FLOW_UPDATE]: ResultServer<any>;
  [ApiType.API_AUDIT_COUNT]: AuditCount;
  [ApiType.API_AUDIT_PAGE_TASK]: ResultServer<any>;
  [ApiType.API_AUDIT_PAGE_TASK_AI_AUDIT]: ResultServer<any>;
  [ApiType.API_AUDIT_PAGE_TASK_MANUAL]: ResultServer<any>;
  [ApiType.API_AUDIT_PAGE_TASK_OFFLINE]: ResultServer<any>;
  [ApiType.API_AUDIT_TASK_DETAIL]: AuditTaskDetail;
  [ApiType.API_AUDIT_RESULT]: ResultServer<any>;
  [ApiType.API_AUDIT_GETSCORELIST]: ScoreList;
  [ApiType.API_AUDIT_GET_CURRENT_TIME_MILLIS]: ResultServer<string>;
  [ApiType.API_DIGITAL_DELETE_CLASSIFY]: ResultServer<any>;
  [ApiType.API_DIGITAL_DELETE_VIDEO]: ResultServer<any>;
  [ApiType.API_AUDIT_PAGEURGENTTASK]: ResultServer<any>;
  [ApiType.API_DIGITAL_ADD_CLASSIFY]: ResultServer<any>;
  [ApiType.API_DIGITAL_ADD_VIDEO]: ResultServer<any>;
  [ApiType.API_DIGITAL_EDIT_VIDEO]: ResultServer<any>;
  [ApiType.API_DIGITAL_PAGE_VIDEO]: DigitalPageVideo;
  [ApiType.API_DIGITAL_QUERY_CLASSIFYTREE]: DigitalQueryClassifytree;
  [ApiType.API_FILE_UPLOAD]: FileType;
  [ApiType.API_AUTH_LOGIN]: AuthLogin;
  [ApiType.API_AUTH_LOGINOUT]: ResultServer<any>;
  [ApiType.API_AUTH_GETUSERINFO]: AuthLogin;
  [ApiType.API_DICT_ADD]: ResultServer<any>;
  [ApiType.API_DICT_DELETE]: ResultServer<any>;
  [ApiType.API_DICT_PAGE]: ResultServer<any>;
  [ApiType.API_DICT_UPDATE]: ResultServer<any>;
  [ApiType.API_DICT_DESC]: ResultServer<any>;
  [ApiType.API_DICT_SEARCH_DISPLAY_TYPE]: DictSearchDisplayType;
  [ApiType.API_QUESTION_PAGE]: ResultServer<QuestionItem[]>;
  [ApiType.API_QUESTION_CREATE]: ResultServer<any>;
  [ApiType.API_QUESTION_DELETE]: ResultServer<any>;
  [ApiType.API_QUESTION_UPDATE]: ResultServer<any>;
  [ApiType.API_QUESTION_CATEGORY_TREE]: ResultServer<QuestionCategoryItem[]>;
  [ApiType.API_QUESTION_CATEGORY_CREATE]: ResultServer<any>;
  [ApiType.API_QUESTION_CATEGORY_DELETE]: ResultServer<any>;
  [ApiType.API_AUTH_VERIFYLOGIN]: ResultServer<any>;
  [ApiType.API_QUESTION_RANDOM_GENERATION_QUESTION]: RandomGenerationQuestion;
  [ApiType.API_CREATE_CLOUD_VIDEO]: ResultServer<any>;
  [ApiType.API_CREATECLOUD_ARCHIVING]: ResultServer<any>;
  [ApiType.API_CREATECLOUD_DELETE]: ResultServer<any>;
  [ApiType.API_INDEX_COUNTINDEXDATA]: CountIndexData;
  [ApiType.API_VIDEOMAKER_GETPROGRESS]: ResultServer<{ mediaUrl: string, progress: string }>;
  [ApiType.API_VIDEOMAKER_VIDEOMAKEADVANCED]: ResultServer<{ taskId: string }>;
  [ApiType.API_VIDEOMAKER_VIDEOPREVIEW]: ResultServer<{ backgroundFileUrl: string, digitalHumanPreviewUrl: string }>;
}
